import { render, staticRenderFns } from "./Profile-User-Info.vue?vue&type=template&id=39500ff6&scoped=true&"
import script from "./Profile-User-Info.vue?vue&type=script&lang=js&"
export * from "./Profile-User-Info.vue?vue&type=script&lang=js&"
import style0 from "./Profile-User-Info.vue?vue&type=style&index=0&id=39500ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39500ff6",
  null
  
)

export default component.exports